import axios from 'axios'
import { SERVER } from '../config'
import { showAlert } from 'services/alerts.service'

// Axios instance with preconfigured baseURL
const instance = axios.create({
  baseURL: `${SERVER.url}/${SERVER.apiPath}`
})

// Sent by the API when the user or its tenant was suspended / deleted by the
// system admin (tokens never expire, so it can happen mid-session).
export const ACCOUNT_DISABLED_MESSAGE = 'Account disabled'

// End the session on an authenticated request rejected that way; the login
// request itself (no token) is left to the login form.
instance.interceptors.response.use(
  response => response,
  error => {
    const { response, config } = error
    if (
      response?.status === 401 &&
      response?.data?.message === ACCOUNT_DISABLED_MESSAGE &&
      config?.headers?.Authorization
    ) {
      localStorage.removeItem('secret')
      localStorage.removeItem('user')
      window.location.assign('/login')
    }
    return Promise.reject(error)
  }
)

const makeRequest = async ({
  method,
  url,
  headers = {},
  data = null,
  alertResult = false,
  responseType = undefined,
  signal = undefined,
  onUploadProgress = undefined
}) => {
  const response = await instance.request({
    method,
    url,
    headers,
    data,
    ...(responseType ? { responseType } : {}),
    ...(signal ? { signal } : {}),
    ...(onUploadProgress ? { onUploadProgress } : {})
  })

  if (alertResult) {
    showAlert({
      text: response?.data?.message || 'Request succeeded',
      icon: 'success'
    })
  }

  if (process.env.NODE_ENV === 'development') {
    console.info(`Request ${method} ${url} succeeded`, response)
  }

  return response
}

export {
  makeRequest
}
